import algoliasearch from "algoliasearch/lite.js";
import instantsearch from "instantsearch.js";

import {
  chamfrClearAllFilters,
  chamfrPagination,
  chamfrRefinementList,
  chamfrResultsHeader,
  chamfrSearchBox,
  chamfrSelectedFilters,
  chamfrSuppliersHits,
} from "./widgets/index.js";
import { hitsPerPage, sortBy } from "instantsearch.js/es/widgets/index.js";

const getQueryFromUrl = () => {
  const params = new URLSearchParams(window.location.search);

  return (
    params.get("[query]") ||
    params.get("%5Bquery%5D") ||
    params.get("query") ||
    params.get("s") ||
    ""
  ).trim();
};

// Function to initialize the supplier directory search
export const initializeSupplierDirectory = () => {
  const search = createSupplierSearchInstance();

  // Adding widgets including custom hits
  search.addWidgets([
    chamfrRefinementList({
      container: document.querySelector(
        "#chamfr-supplier-directory .chamfr-suppliers-markets"
      ),
      attribute: "supplier_market",
      limit: 10,
      showMore: true,
      showMoreLimit: 100,
    }),
    chamfrRefinementList({
      container: document.querySelector(
        "#chamfr-supplier-directory .chamfr-suppliers-categories"
      ),
      attribute: "supplier_category",
      limit: 10,
      showMore: true,
      showMoreLimit: 100,
    }),
    chamfrRefinementList({
      container: document.querySelector(
        "#chamfr-supplier-directory .chamfr-suppliers-service-type"
      ),
      attribute: "service_type",
      limit: 10,
      showMore: true,
      showMoreLimit: 100,
    }),
    chamfrSuppliersHits({
      container: document.querySelector(
        "#chamfr-supplier-directory .chamfr-suppliers-companies"
      ),
    }),
    chamfrResultsHeader({
      container: document.querySelector(
        "#chamfr-supplier-directory .results-header"
      ),
    }),
    hitsPerPage({
      container: document.querySelector(
        "#chamfr-supplier-directory .display-per-page span"
      ),
      items: [
        { label: "30 Items", value: 30, default: true },
        { label: "100 Items", value: 100 },
        { label: "All Items", value: 1000 },
      ],
    }),
    sortBy({
      container: document.querySelector(
        "#chamfr-supplier-directory .sort-by span"
      ),
      items: [
        { label: "Relevance", value: algolia.supplier_index_name },
        { label: "A-Z", value: `${algolia.supplier_index_name}_az` },
        { label: "Z-A", value: `${algolia.supplier_index_name}_za` },
      ],
    }),
    chamfrPagination({
      container: document.querySelector(
        "#chamfr-supplier-directory .chamfr-pagination"
      ),
    }),
    chamfrSearchBox({
      container: document.querySelector(
        "#chamfr-supplier-directory .search-form"
      ),
	  label: "Search within these results"
    }),
    chamfrSelectedFilters({
      container: document.querySelector(
        "#chamfr-supplier-directory .selected-filters ul"
      ),
      indexClass: "suppliers",
    }),
    chamfrClearAllFilters({
      container: document.querySelector(
        "#chamfr-supplier-directory .selected-filters .clear-all-filters"
      ),
    }),
  ]);

  search.start();
};

// Function to create the InstantSearch instance
const createSupplierSearchInstance = () => {
  const indexName = algolia.supplier_index_name;
  const query = getQueryFromUrl();
  const settings = {
    indexName: indexName,
    searchClient: algoliasearch(algolia.application_id, algolia.search_api_key),
    userToken: algolia.user_info.user_token,
  };

  if (query) {
    settings.initialUiState = {
      [indexName]: { query },
    };
  }

  return instantsearch(settings);
};
